<div class="m-3">
  <mat-card>
    @if (items.length) {
      <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
        @for (item of items; track item) {
          <div cdkDrag class="example-box text-black" style="cursor: auto">
            <div class="d-flex justify-content-start align-items-center w-50 overflow-hidden gap-2">
              <div class="d-flex center text-start">
                <app-icon cdkDragHandle class="drag-icon text-nowrap"> drag_indicator </app-icon>
              </div>
              <div class="d-flex flex-column text-truncate text-start">
                <span class="text-truncate">{{ item.name }}</span>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <app-button btnType="icon" (onChangeClick)="onUpdateColumn(item)">
                <app-icon>edit</app-icon>
              </app-button>
              <app-button btnType="icon" (onChangeClick)="onDeleteColumn(item)">
                <app-icon>delete</app-icon>
              </app-button>
            </div>
            <div class="px-2 create-column d-flex center">
              <div class="d-flex center text-secondary click-css" (click)="openCreateModal(item)">
                <app-icon class="rounded-circle bg-white">add_circle_outline</app-icon>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </mat-card>
  @if (isLoader) {
    <div class="d-flex justify-content-center">
      <app-loader size="small"></app-loader>
    </div>
  }
  @if (!items.length && !isLoader) {
    <div class="mt-2 d-flex flex-column align-items-center justify-content-center gap-4">
      <span class="text-center text-dark">{{ 'there_are_no_columns' | translate }}</span>
      <app-button (onChangeClick)="openCreateModal()">{{ 'add_a_column' | translate }}</app-button>
    </div>
  }
</div>
